import { Params } from '@angular/router';

export const getNumericValuesFromURLParams = (params: Params, key: string): number[] => {
	if (!params[key]) {
		return [];
	}

	return params[key]?.split(',').map((value: string) => {
		if (isNaN(Number(value))) {
			throw new Error(`Nieprawidłowa wartość numeryczna w linku dla klucza: ${key}. Wartość: ${value}`);
		}

		return Number(value);
	});
};
